module.exports = __webpack_public_path__ + "static/media/google-pay.8f86cf5d.svg";